<template>
  <section>

    <div v-if="Number(userInfo.crmCustomerType) === 1">
      <div class="personal-center-form__section_person">
        <h1 class="personal-center-form__title">个人信息</h1>
          <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
          <!--个人信息-->
            <el-tab-pane label="个人信息" style="color:#EB662B;" name="first">
               <router-view></router-view>
            </el-tab-pane>

          </el-tabs>
      </div>
    </div>
    <div v-if="Number(userInfo.crmCustomerType) === 2">
      <div class="personal-center-form__section">
        <h1 class="personal-center-form__title">企业信息</h1>
        <div class="personal-center-form__main">
          <el-row :gutter="0" class="personal-center-form__form">
            <el-col :span="16">
              <el-form :label-width="'50%'" :model="enterpriseInfoFormModel" :rules="rules" ref="myInfoForm">
                <el-form-item label="客户名称" prop="customerName">
                  <el-input type="text" placeholder="请输入客户名称" :disabled="isEditable === 1 || authStatus === 1 || authStatus === 2"
                            v-model="enterpriseInfoFormModel.customerName" :maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="营业执照号"  prop="enterpriseNumber">
                  <el-input type="text" placeholder="请输入营业执照号" :disabled="isEditable === 1 || authStatus === 1 || authStatus === 2"
                            v-model="enterpriseInfoFormModel.enterpriseNumber" :maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="股东人数" prop="enterprisePartnerNumber">
                  <el-input type="text" placeholder="请输入股东人数"
                            v-model="enterpriseInfoFormModel.enterprisePartnerNumber"></el-input>
                </el-form-item>
                <el-form-item label="所属行业" prop="enterpriseIndustry">
                  <el-select v-model="enterpriseInfoFormModel.enterpriseIndustry" placeholder="请选择所属行业">
                    <el-option
                      v-for="item in belongIndustryList"
                      :key="item.itemValue"
                      :label="item.itemName"
                      :value="item.itemValue">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="企业规模" prop="enterpriseScale">
                  <el-select v-model="enterpriseInfoFormModel.enterpriseScale" placeholder="请选择企业规模">
                    <el-option
                      v-for="item in corporationscaleList"
                      :key="item.itemValue"
                      :label="item.itemName"
                      :value="item.itemValue">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="省份" prop="province">
                  <el-select @change="getCityList" v-model="enterpriseInfoFormModel.province" placeholder="请选择省份">
                    <el-option
                      v-for="item in provinceList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="城市" prop="city">
                  <el-select v-model="enterpriseInfoFormModel.city" placeholder="请选择城市">
                    <el-option
                      v-for="item in cityList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="注册地址" prop="enterpriseRegAddr">
                  <el-input type="textarea" placeholder="请输入注册地址" :maxlength='30' resize="none" :rows="2"
                            v-model="enterpriseInfoFormModel.enterpriseRegAddr"></el-input>
                </el-form-item>
                <el-form-item label="办公地址" prop="enterpriseOfficeAddress">
                  <el-input type="textarea" placeholder="请输入办公地址" :maxlength='30' resize="none" :rows="2"
                            v-model="enterpriseInfoFormModel.enterpriseOfficeAddress"></el-input>
                </el-form-item>
                <el-form-item label="企业性质" prop="enterpriseType">
                  <el-select v-model="enterpriseInfoFormModel.enterpriseType" placeholder="请选择">
                    <el-option
                      v-for="item in enterpriseInfoFormModel.enterpriseTypeArray"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="注册资金" prop="enterpriseRegMoney" class="enterpriseRegMoney_main">
                  <el-input type="number" placeholder="请输入注册资金"
                            v-model="enterpriseInfoFormModel.enterpriseRegMoney"></el-input>
                  <span class="enterpriseRegMoney_unit">万</span>
                </el-form-item>
                <!-- <el-form-item label="注册人类型" :required="true" prop="userType">
                  <el-radio-group v-model="enterpriseInfoFormModel.userType" :disabled="isEditable === 1 || authStatus === 1 || authStatus === 2">
                    <el-radio :label="2">法定代表人注册</el-radio>
                    <el-radio :label="1">代理人注册</el-radio>
                  </el-radio-group>
                </el-form-item> -->
                <el-form-item :label="Number(enterpriseInfoFormModel.userType) === 2 ? '法定代表人' : '代理人'" prop="enterpriseLegalUser">
                  <el-input type="text" :placeholder="Number(enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人' : '请输入代理人'" :disabled="isEditable === 1 || authStatus === 1 || authStatus === 2"
                            v-model="enterpriseInfoFormModel.enterpriseLegalUser" :maxlength="30"></el-input>
                </el-form-item>
                <el-form-item :label="Number(enterpriseInfoFormModel.userType) === 2 ? '法定代表人身份证号' : '代理人身份证号'" prop="enterpriseLegalIdNo">
                  <el-input type="text" :placeholder="Number(enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人身份证号' : '请输入代理人身份证号'" :disabled="isEditable === 1 || authStatus === 1 || authStatus === 2"
                            v-model="enterpriseInfoFormModel.enterpriseLegalIdNo" :maxlength="30"></el-input>
                </el-form-item>
                <el-form-item :label="Number(enterpriseInfoFormModel.userType) === 2 ? '法定代表人联系电话':'代理人联系电话'" prop="enterpriseLegalUserPhone">
                  <el-input type="tel" :placeholder="Number(enterpriseInfoFormModel.userType) === 2 ?'请输入法定代表人联系电话':'请输入法定代表人联系电话'" :disabled="isEditable === 1 || authStatus === 1 || authStatus === 2" :maxlength="11"
                            v-model="enterpriseInfoFormModel.enterpriseLegalUserPhone"></el-input>
                </el-form-item>
                <el-form-item label="企业注册类型" :required="true" prop="registrationType">
                  <el-radio-group v-model="enterpriseInfoFormModel.registrationType" :disabled="isEditable === 1 || authStatus === 1 || authStatus === 2">
                    <el-radio :label="1">多证合一</el-radio>
                    <el-radio :label="0">组织机构代码证号</el-radio>
                  </el-radio-group>
                </el-form-item>
                <template>
                  <el-form-item v-if="Number(enterpriseInfoFormModel.registrationType) === 0" label="组织机构代码证号" prop="enterpriseOrganizingNumber">
                    <el-input type="text" placeholder="请输入组织机构代码证号"
                              v-model="enterpriseInfoFormModel.enterpriseOrganizingNumber" :maxlength="30" :disabled="isEditable === 1 || authStatus === 1 || authStatus === 2"></el-input>
                  </el-form-item>

                  <el-form-item v-else label="社会信用代码号"  prop="enterpriseOrganizingNumber">
                    <el-input type="text" placeholder="请输入社会信用代码号"
                              v-model="enterpriseInfoFormModel.enterpriseOrganizingNumber" :maxlength="30" :disabled="isEditable === 1 || authStatus === 1 || authStatus === 2"></el-input>
                  </el-form-item>
                </template>
                <el-form-item label="国税登记证号" prop="enterpriseNationalNumber">
                  <el-input type="text" placeholder="请输入国税登记证号"
                            v-model="enterpriseInfoFormModel.enterpriseNationalNumber" :maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="地税登记证号" prop="enterpriseGovernmentNumber">
                  <el-input type="text" placeholder="请输入地税登记证号"
                            v-model="enterpriseInfoFormModel.enterpriseGovernmentNumber" :maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="登记机关" prop="enterpriseRegOrgan">
                  <el-input type="text" placeholder="请输入登记机关"
                            v-model="enterpriseInfoFormModel.enterpriseRegOrgan" :maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="从业人数" prop="enterpriseEmployeeNum">
                  <el-input type="text" placeholder="请输入从业人数"
                            v-model="enterpriseInfoFormModel.enterpriseEmployeeNum" :maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="经营范围" prop="enterpriseScope">
                  <el-input type="textarea" placeholder="请输入经营范围" :maxlength='1000' resize="none" :rows="10"
                            v-model="enterpriseInfoFormModel.enterpriseScope"></el-input>
                </el-form-item>
                <el-form-item label="成立背景" prop="enterpriseFoundExplain">
                  <el-input type="textarea" placeholder="请输入成立背景" :maxlength='1000' resize="none" :rows="10"
                            v-model="enterpriseInfoFormModel.enterpriseFoundExplain"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <div class="text-center">
            <el-button type="primary" :loading="isLoading" style="background:#84A232;" class="personal-center-form__submit" @click="submitForm">提交
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import api from '../../vuex/api';
  import placeholders from '../../scripts/placeholders';

  import {mapGetters, mapActions} from 'vuex';
  import * as types from '../../vuex/types';
  import _ from 'lodash';

  // 企业那边如果界面差异变大，则建议分出去另一个组件
  export default {
    data () {
      const assignValidator = (type, trigger = 'blur') => Object.assign({
        required: true,
        trigger
      }, {
        validator: (rules, value, callback, source, options) => {
          this.$store.dispatch(type, {rules, value, callback, source, options});
        }
      });
      return {
        isLoading: false,
        isLoading2: 1,
        activeName: 'first',
        isEditable: '',
        authStatus: '',
        rules: {
          realName: [assignValidator((types.VERIFY_CHN_NAME))],
          IDCardNum: [assignValidator(types.VERIFY_ID_CARD_NUM)],

          cellphone: [assignValidator(types.VERIFY_CELLPHONE)],
          enterpriseNumber: [assignValidator(types.VERIFY_ENTERPRISE_NUMBER)],
          customerName: [{
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('客户名称不能为空'));
              } else {
                callback();
              }
            }
          }],
          enterpriseOrganizingNumber: [{
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (Number(this.enterpriseInfoFormModel.registrationType) === 0) {
                if (_.trim(value) === '') {
                  callback(new Error('组织机构代码证号不能为空'));
                } else {
                  callback();
                }
              } else {
                if (_.trim(value) === '') {
                  callback(new Error('社会信用代码号不能为空'));
                } else {
                  callback();
                }
              }
            }
          }],
          enterpriseOfficeAddress: [{
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('办公地址不能为空'));
              } else {
                callback();
              }
            }
          }],
          userType: [{
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择'));
              } else {
                callback();
              }
            }
          }],
          registrationType: [{
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择'));
              } else {
                callback();
              }
            }
          }],
          enterpriseLegalUser: [assignValidator((types.VERIFY_CHN_NAME))],
          enterpriseLegalUserPhone: [assignValidator(types.VERIFY_CELLPHONE)],
          enterpriseLegalIdNo: [assignValidator(types.VERIFY_ID_CARD_NUM)]
        },
        myInfoFormModel: {
          realName: '',
          IDCardNum: '',
          cellphone: ''
        },
        enterpriseInfoFormModel: {
          customerName: '',
          enterpriseNumber: '',
          enterprisePartnerNumber: '',
          enterpriseRegAddr: '',
          enterpriseOfficeAddress: '',
          enterpriseType: '',
          enterpriseRegMoney: '',
          enterpriseLegalUser: '',
          enterpriseLegalUserPhone: '',
          enterpriseLegalIdNo: '',
          enterpriseOrganizingNumber: '',
          enterpriseScale: '',
          enterpriseNationalNumber: '',
          enterpriseGovernmentNumber: '',
          enterpriseRegOrgan: '',
          enterpriseEmployeeNum: '',
          enterpriseScope: '',
          enterpriseFoundExplain: '',
          enterpriseScaleArray: [],
          enterpriseTypeArray: [],
          userType: 2,
          registrationType: 0,
          province:'',
          city:'',
          enterpriseIndustry:''
        },
        provinceList: [],
        cityList: [],
        belongIndustryList: [],
        corporationscaleList: [],
        provinceCode: ''
      };
    },
    computed: {
      ...mapGetters({
        myInfo: types.GET_MY_INFO,
        userInfo: types.GET_USER
      })
    },
    methods: {
      ...mapActions({
        updatePassword: types.UPDATE_PASSWORD,
        getPersonalInfo: types.GET_PERSONAL_INFO,
        getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
        savePersonalInfo: types.SAVE_PERSONAL_INFO,
        saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
        setSuccessMessage: types.SET_SUCCESS_MESSAGE
      }),
      submitForm () {
        this.$refs.myInfoForm.validate((valid) => {
          if (valid) {
            this.isLoading = true;
            if (this.userInfo.crmCustomerType === '1') {
              this.personalSubmit();
            } else {
              this.enterpriseSubmit();
            }
          } else {
            setTimeout(() => {
              placeholders.placeHolder(this);
            }, 30);
            return false;
          }
        });
      },
      checkPhone (val) {
        this.myInfoFormModel.cellphone = this.myInfoFormModel.cellphone.replace(/\D/, '');
      },
      handleClick (tab, event) {
        this.$router.push({
          path: '/personalCenter/myInfo/PersonInfo'
        });
      },
      personalSubmit () {
        // 个人
        this.savePersonalInfo({
          router: this.$router,
          token: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId,
          customerName: this.myInfoFormModel.realName,
          personIdentityCard: this.myInfoFormModel.IDCardNum
        }).then((res) => {
          this.isLoading = false;
          if (Number(res.data.code) === 0) {
            this.isEditable = 1;
            this.setSuccessMessage({
              show: true,
              content: '实名认证成功'
            });
          }
        });
      },
      enterpriseSubmit () {
        // 企业
        this.saveEnterpriseInfo({
          router: this.$router,
          token: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId,
          customerName: this.enterpriseInfoFormModel.customerName,
          enterpriseNumber: this.enterpriseInfoFormModel.enterpriseNumber,
          enterprisePartnerNumber: this.enterpriseInfoFormModel.enterprisePartnerNumber,
          enterpriseRegAddr: this.enterpriseInfoFormModel.enterpriseRegAddr,
          enterpriseOfficeAddress: this.enterpriseInfoFormModel.enterpriseOfficeAddress,
          enterpriseType: this.enterpriseInfoFormModel.enterpriseType,
          enterpriseRegMoney: this.enterpriseInfoFormModel.enterpriseRegMoney,
          enterpriseLegalUser: this.enterpriseInfoFormModel.enterpriseLegalUser,
          enterpriseLegalIdNo: this.enterpriseInfoFormModel.enterpriseLegalIdNo,
          enterpriseLegalUserPhone: this.enterpriseInfoFormModel.enterpriseLegalUserPhone,
          enterpriseOrganizingNumber: this.enterpriseInfoFormModel.enterpriseOrganizingNumber,
          enterpriseScale: this.enterpriseInfoFormModel.enterpriseScale,
          enterpriseNationalNumber: this.enterpriseInfoFormModel.enterpriseNationalNumber,
          enterpriseGovernmentNumber: this.enterpriseInfoFormModel.enterpriseGovernmentNumber,
          enterpriseRegOrgan: this.enterpriseInfoFormModel.enterpriseRegOrgan,
          enterpriseEmployeeNum: this.enterpriseInfoFormModel.enterpriseEmployeeNum,
          enterpriseScope: this.enterpriseInfoFormModel.enterpriseScope,
          enterpriseFoundExplain: this.enterpriseInfoFormModel.enterpriseFoundExplain,
          userType: this.enterpriseInfoFormModel.userType,
          registrationType: this.enterpriseInfoFormModel.registrationType,
          province: this.enterpriseInfoFormModel.province,
          city: this.enterpriseInfoFormModel.city,
          enterpriseIndustry: this.enterpriseInfoFormModel.enterpriseIndustry
        }).then((res) => {
          this.isLoading = false;
          if (Number(res.data.code) === 0) {
//            this.isEditable = 1
            this.setSuccessMessage({
              show: true,
              content: '企业信息保存成功'
            });
//          } else {
//            this.isEditable = ''
          }
        });
      },
      // 获取省份列表
      getProvinceList () {
        api.getProvinceList().then((res) => {
          const resData = res.data
          if (resData.code == 0) {
            this.provinceList = resData.result.provinceList;
          } else {
            this.setFailMessage({
              show: true,
              content: resData.msg || "获取省份列表信息失败",
            });
          }
        });
      },
      // 获取城市列表
      getCityList (parentCode) {
        if (parentCode == undefined || parentCode == '') {
          return;
        }
        const param = {
          parentCode: parentCode
        };
        api.getCityList(param).then((res) => {
          const resData = res.data
          if (resData.code == 0) {
            this.cityList = resData.result.cityList;
            if(this.cityList != null && this.cityList.length != 0) {
              if (parentCode != this.provinceCode) {
                this.enterpriseInfoFormModel.city = this.cityList[0].code;
              }
            } else {
              this.enterpriseInfoFormModel.city = '';
            }
            this.provinceCode = parentCode
          } else {
            this.setFailMessage({
              show: true,
              content: resData.msg || "获取城市列表信息失败",
            });
          }
        });
      },
      // 获取所属行业
      getBelongIndustryList () {
        api.getBelongIndustryList().then((res) => {
          const resData = res.data
          if (resData.code == 0) {
            this.belongIndustryList = resData.result.belongIndustryList;
          } else {
            this.setFailMessage({
              show: true,
              content: resData.msg || "获取所属行业信息失败",
            });
          }
        });
      },
      // 获取企业规模
      getCorporationscaleList () {
        api.getCorporationscaleList().then((res) => {
          const resData = res.data
          if (resData.code == 0) {
            this.corporationscaleList = resData.result.corporationscaleList;
          } else {
            this.setFailMessage({
              show: true,
              content: resData.msg || "获取企业规模信息失败",
            });
          }
        });
      }
    },
    directives: {
      myDirective: {
        bind: (el) => {
          const input = el.querySelector('input');

          const isIE = /(msie|trident.*rv:)/i.test(navigator.userAgent);
          input.addEventListener(isIE ? 'keyup' : 'input', (e) => {
            input.value = input.value.replace(/\D/g, '');
          });
        }
      }
    },
    updated () {
      if (this.$route.path.indexOf('PersonInfo') == -1) {
        this.activeName = 'first';
      }
    },
    mounted () {
      if (this.userInfo.crmCustomerType === '1') {
        // 个人
        this.getPersonalInfo({
          router: this.$router,
          token: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId
        }).then((res) => {
          if (Number(res.data.code) === 0) {
            const data = res.data.data;
            if (data.customerName && data.personIdentityCard) {
              this.isEditable = 1;
            }
            // this.isEditable = Number(data.isEditable)
            this.myInfoFormModel = {
              realName: (data.customerName != null ? data.customerName : ''),
              IDCardNum: data.personIdentityCard,
              cellphone: data.mobile
            };
          }
        });
        this.handleClick();
      } else {
        // 企业
        this.getEnterpriseInfo({
          router: this.$router,
          token: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId
        }).then((res) => {
          this.authStatus = Number(res.data.authStatus);
          if (Number(res.data.code) === 0) {
            const data = res.data;
            this.isEditable = Number(data.isEditable);
            this.enterpriseInfoFormModel = {
              customerName: (data.customerName != null ? data.customerName : ''),
              enterpriseNumber: (data.crmCustomerEnterprise.enterpriseNumber != null ? data.crmCustomerEnterprise.enterpriseNumber : ''),
              enterprisePartnerNumber: (data.crmCustomerEnterprise.enterprisePartnerNumber != null ? data.crmCustomerEnterprise.enterprisePartnerNumber : ''),
              enterpriseRegAddr: (data.crmCustomerEnterprise.enterpriseRegAddr != null ? data.crmCustomerEnterprise.enterpriseRegAddr : ''),
              enterpriseOfficeAddress: (data.crmCustomerEnterprise.enterpriseOfficeAddress != null ? data.crmCustomerEnterprise.enterpriseOfficeAddress : ''),
              enterpriseType: (data.crmCustomerEnterprise.enterpriseType != null ? data.crmCustomerEnterprise.enterpriseType : ''),
              enterpriseRegMoney: (data.crmCustomerEnterprise.enterpriseRegMoney != null ? data.crmCustomerEnterprise.enterpriseRegMoney : ''),
              enterpriseLegalUser: (data.crmCustomerEnterprise.enterpriseLegalUser != null ? data.crmCustomerEnterprise.enterpriseLegalUser : ''),
              enterpriseLegalIdNo: (data.crmCustomerEnterprise.enterpriseLegalIdNo != null ? data.crmCustomerEnterprise.enterpriseLegalIdNo : ''),
              enterpriseLegalUserPhone: (data.crmCustomerEnterprise.enterpriseLegalUserPhone != null ? data.crmCustomerEnterprise.enterpriseLegalUserPhone : ''),
              enterpriseOrganizingNumber: (data.crmCustomerEnterprise.enterpriseOrganizingNumber != null ? data.crmCustomerEnterprise.enterpriseOrganizingNumber : ''),
              enterpriseScale: (data.crmCustomerEnterprise.enterpriseScale != null ? data.crmCustomerEnterprise.enterpriseScale : ''),
              enterpriseNationalNumber: (data.crmCustomerEnterprise.enterpriseNationalNumber != null ? data.crmCustomerEnterprise.enterpriseNationalNumber : ''),
              enterpriseGovernmentNumber: (data.crmCustomerEnterprise.enterpriseGovernmentNumber != null ? data.crmCustomerEnterprise.enterpriseGovernmentNumber : ''),
              enterpriseRegOrgan: (data.crmCustomerEnterprise.enterpriseRegOrgan != null ? data.crmCustomerEnterprise.enterpriseRegOrgan : ''),
              enterpriseEmployeeNum: (data.crmCustomerEnterprise.enterpriseEmployeeNum != null ? data.crmCustomerEnterprise.enterpriseEmployeeNum : ''),
              enterpriseScope: (data.crmCustomerEnterprise.enterpriseScope != null ? data.crmCustomerEnterprise.enterpriseScope : ''),
              enterpriseFoundExplain: (data.crmCustomerEnterprise.enterpriseFoundExplain != null ? data.crmCustomerEnterprise.enterpriseFoundExplain : ''),
              enterpriseScaleArray: (data.enterpriseScaleArray != null ? data.enterpriseScaleArray : ''),
              enterpriseTypeArray: (data.enterpriseTypeArray != null ? data.enterpriseTypeArray : ''),
              userType: (data.crmCustomerEnterprise.userType != null ? Number(data.crmCustomerEnterprise.userType) : 2),
              registrationType: (data.crmCustomerEnterprise.registrationType != null ? Number(data.crmCustomerEnterprise.registrationType) : 0),
              province: (data.crmCustomerEnterprise.province != null ? data.crmCustomerEnterprise.province : ''),
              city: (data.crmCustomerEnterprise.city != null ? data.crmCustomerEnterprise.city : ''),
              enterpriseIndustry: (data.crmCustomerEnterprise.enterpriseIndustry != null ? data.crmCustomerEnterprise.enterpriseIndustry : '')
            };
            this.provinceCode = (this.enterpriseInfoFormModel.province != null ? this.enterpriseInfoFormModel.province : '');
            this.getProvinceList();
            // this.getCityList(data.enterpriseInfoFormModel.province);
            this.getBelongIndustryList();
            this.getCorporationscaleList(); 
            console.log(data.crmCustomerEnterprise.enterpriseRegMoney);
          }
        });
      }
    }
  };
</script>
<style lang="scss">
  .personal-center-form__section {
    .enterpriseRegMoney_main{
      position: relative;
      .enterpriseRegMoney_unit{
        position: absolute;
        right:-20px;
        top: 0;
      }

    }
    .el-form-item {
      height: auto;
          float: left;
    }
    /*    input[readonly='readonly'] {
          background: #f7f7f7;
        }*/
    .el-input.is-disabled .el-input__inner {
      background: #f7f7f7;
    }
    .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
      color: #fff;
      cursor: not-allowed;

      background: #c6c6c6 none;
      border: none;
    }
    .el-radio__input.is-focus .el-radio__inner {
      border-color: #EB662B;
      background: #EB662B !important;
    }
    .el-radio__input .el-radio__inner:hover {
      border-color: #EB662B;
    }
    .el-radio__input.is-focus .el-radio__inner::after {
      -ms-transform: translate(-50%, -50%) scale(1);
      transform: translate(-50%, -50%) scale(1);
    }
    .el-radio__inner::after {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #fff;
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      -ms-transform: translate(-50%, -50%) scale(0);
      transform: translate(-50%, -50%) scale(0);
      transition: transform .15s cubic-bezier(.71, -.46, .88, .6);
    }
  }
  .personal-center-form__section_person {
    .enterpriseRegMoney_main{
      position: relative;
      .enterpriseRegMoney_unit{
        position: absolute;
        right:-20px;
        top: 0;
      }

    }
    .el-form-item {
      height: auto;
    }
    /*    input[readonly='readonly'] {
          background: #f7f7f7;
        }*/
    .el-input.is-disabled .el-input__inner {
      background: #f7f7f7;
    }
    .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
      color: #fff;
      cursor: not-allowed;

      background: #c6c6c6 none;
      border: none;
    }
    .el-radio__input.is-focus .el-radio__inner {
      border-color: #EB662B;
      background: #EB662B !important;
    }
    .el-radio__input .el-radio__inner:hover {
      border-color: #EB662B;
    }
    .el-radio__input.is-focus .el-radio__inner::after {
      -ms-transform: translate(-50%, -50%) scale(1);
      transform: translate(-50%, -50%) scale(1);
    }
    .el-radio__inner::after {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #fff;
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      -ms-transform: translate(-50%, -50%) scale(0);
      transform: translate(-50%, -50%) scale(0);
      transition: transform .15s cubic-bezier(.71, -.46, .88, .6);
    }
  }
</style>



// WEBPACK FOOTER //
// MyInfo.vue?49f0128a